"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultSharedStore = void 0;
const rxjs_1 = require("rxjs");
const lodash_keys_1 = __importDefault(require("lodash.keys"));
const operators_1 = require("rxjs/operators");
const react_dom_1 = require("react-dom");
class DefaultSharedStore {
    constructor() {
        this.store = {};
        this.subjects = {};
        this.anyChangeSubject = new rxjs_1.Subject();
        this.collectionChanges = {};
    }
    getValue(key) {
        return this.store[key];
    }
    setValue(key, value) {
        if (this.setStoreValue(key, value)) {
            this.getSubject(key).next(value);
            this.anyChangeSubject.next([key]);
        }
    }
    update(update) {
        const updateKeys = lodash_keys_1.default(update);
        if (!updateKeys || updateKeys.length < 1)
            return; // noop if no update provided
        const updated = [];
        react_dom_1.unstable_batchedUpdates(() => {
            for (const key of updateKeys) {
                const value = update[key];
                if (this.setStoreValue(key, value)) {
                    updated.push(key);
                }
            }
            this.anyChangeSubject.next(updated);
            for (const key of updated) {
                this.getSubject(key).next(update[key]);
            }
        });
    }
    onChange(keys) {
        if (this.isSingleKey(keys)) {
            return this.getSubject(keys);
        }
        else {
            return this.onAnyOfKeysChange(keys);
        }
    }
    /*eslint-enable no-dupe-class-members*/
    isSingleKey(keys) {
        return typeof keys === 'string';
    }
    onAnyChange() {
        return this.anyChangeSubject;
    }
    delete(keys) {
        react_dom_1.unstable_batchedUpdates(() => {
            keys.forEach(key => delete this.store[key]);
            keys.forEach(key => {
                const subject = this.subjects[key];
                if (subject)
                    subject.next(undefined);
            });
            this.anyChangeSubject.next(keys);
        });
    }
    allKeys() {
        return lodash_keys_1.default(this.store);
    }
    hasKey(key) {
        return key in this.store;
    }
    getSubject(key) {
        const subject = this.subjects[key];
        if (subject === undefined) {
            return (this.subjects[key] = new rxjs_1.Subject());
        }
        return subject;
    }
    setStoreValue(key, value) {
        const newValue = this.store[key] !== value;
        if (newValue) {
            this.store[key] = value;
            if (this.isCollection(value)) {
                this.attachCollectionChangeEvents(key, value);
            }
        }
        return newValue;
    }
    attachCollectionChangeEvents(key, collection) {
        const sub = this.collectionChanges[key];
        if (sub)
            sub.unsubscribe();
        this.collectionChanges[key] = collection.onAnyChange().subscribe(() => {
            this.anyChangeSubject.next([key]);
        });
    }
    isCollection(value) {
        return value instanceof DefaultSharedStore;
    }
    onAnyOfKeysChange(keys) {
        if (!keys)
            return rxjs_1.empty();
        return this.anyChangeSubject.pipe(operators_1.filter(updated => {
            return updated.some(updatedKey => keys.some(key => key === updatedKey));
        }), operators_1.map(() => { }));
    }
}
exports.DefaultSharedStore = DefaultSharedStore;
//# sourceMappingURL=default-shared-store.js.map